import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditStatsCard = ({ title, value, icon, color = 'primary' }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'bg-success/10 text-success';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'error':
        return 'bg-error/10 text-error';
      case 'primary':
      default:
        return 'bg-primary/10 text-primary';
    }
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 shadow-therapeutic transition-smooth hover:shadow-therapeutic-md">
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getColorClasses()}`}>
          <Icon name={icon} size={20} strokeWidth={2} />
        </div>
      </div>
      <div>
        <p className="text-2xl sm:text-3xl font-heading font-bold text-foreground mb-1">
          {value?.toLocaleString()}
        </p>
        <p className="text-sm text-muted-foreground">{title}</p>
      </div>
    </div>
  );
};

export default AuditStatsCard;